<template>
  <div :class="['b-stepper sm:gap-2', size]">
    <button
      class="subtract"
      @click="decrease"
      :disabled="disabled || disableDecreaseBtn || (min != null && min >= counter)"
    >
      <span class="icon icon-bor-subtract"></span>
    </button>
    <div class="show-number">
      <a-input
        class="stepper-input"
        :class="{ readonly }"
        v-model="inputValue"
        :size="size"
        @focus="onFocus"
        @blur="onBlur"
        @keydown="handleKeydown"
        @keyup="handleKeyup"
        @input="handleInput"
        :disabled="disabled || disableInput || readonly"
      />
    </div>
    <button
      class="plus"
      @click="increase"
      :disabled="disabled || disableIncreaseBtn || (max != null && max <= counter)"
    >
      <span class="icon icon-plus-action">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
      </span>
    </button>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { KEY_INTEGER_REGEX } from '@/constants/number'

export default {
  name: 'b-stepper',
  props: {
    value: {
      default: 0
    },
    type: {
      type: String,
      default: 'interger'
    },
    max: {
      default: null
    },
    min: {
      default: 0
    },
    size: {
      type: String,
      default: 'default'
    },
    unit: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disableDecreaseBtn: {
      type: Boolean,
      default: false
    },
    disableIncreaseBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      counter: this.min ? this.min : 0,
      inputValue: this.min ? this.min : 0,
      inFocus: false
    }
  },
  created() {
    this.counter = +this.value
    this.inputValue = `${this.counter}${this.unit ? `${this.unit}` : this.unit}`
  },
  watch: {
    value(val) {
      this.counter = +val
      this.updateInputValue()
    },
    counter(value, old) {
      if (old != value) {
        this.$emit('input', value)
        this.$emit('change')
      }
    },
    inputValue(value) {
      if (value !== null && !isNaN(parseInt(value))) {
        if (this.inFocus && String(value).startsWith('0') && value !== parseInt(value)) {
          this.inputValue = parseInt(value)
        }

        if (this.max !== null && parseInt(value) > this.max) {
          this.inputValue = this.max
          return
        }
        if (this.min !== null && parseInt(value) < this.min) {
          this.inputValue = this.min
          return
        }
        this.counter = parseInt(value)
      }
    }
  },
  methods: {
    updateInputValue() {
      if (!this.inFocus) {
        if (this.inputValue === null || this.inputValue === '') {
          this.counter = 0
        }
        this.inputValue = String(
          `${this.counter}${this.unit ? `${this.unit}` : this.unit}`
        ).trim()
      }
    },
    onFocus() {
      this.inFocus = true
      if (this.inputValue) {
        this.inputValue = String(this.inputValue).replace(this.unit, '').trim()
      }
    },
    onBlur() {
      this.inFocus = false
      this.updateInputValue()
    },
    increase() {
      if (this.max !== null && this.counter >= this.max) {
        return
      }
      this.counter++
      this.updateInputValue()
    },
    decrease() {
      if (this.min !== null && this.counter <= this.min) {
        return
      }
      this.counter--
      this.updateInputValue()
    },
    handleKeydown($event) {
      const key = $event.key
      if (
        !key.match(KEY_INTEGER_REGEX) &&
        !['Backspace', 'ArrowLeft', 'ArrowRight'].includes(key)
      ) {
        $event.preventDefault()
        return false
      }
      this.$emit('keydown', $event)
      return true
    },
    handleKeyup($event) {
      this.$emit('keyup', $event)
    },
    handleInput($event) {
      this.inputValue = this.inputValue
        .split('人')
        .map((e) => e.trim())
        .join('')
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
